import ConnectionsList from "./ConnectionsList";

const BlockedUsersList = () => {
  return <ConnectionsList variant="blocked" />;
};

export default BlockedUsersList;
